<div class="maintenance-banner" [style.display]="mostrarBanner ? 'block' : 'none'">
  <div class="banner-content">
    <div class="banner-icon">
      <nb-icon icon="alert-triangle-outline" status="warning"></nb-icon>
    </div>
    <div class="banner-message">
      <span class="message-text">{{ mensagem }}</span>
    </div>
  </div>
</div>
